import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full py-12 md:py-20 bg-[#FDF8F4]/90" data-id="element-62">
      <div className="max-w-6xl mx-auto px-6" data-id="element-63">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-64">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-65">
            <h1 className="font-lora text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal leading-tight mb-6" data-id="element-66">
              "El Protocolo de 5 Minutos Usado en Emergencias para Desactivar la
              Ansiedad en Tiempo Real (Sin Pastillas ni Meditación)" es de Clase
              A.
            </h1>
            <p className="font-inter text-lg text-charcoal/80 mb-8" data-id="element-67">
              El protocolo científico que tu sistema nervioso ya sabe ejecutar,
              pero que nadie te enseñó a activar.
            </p>
            <motion.a href="#comprar" className="inline-block font-inter font-semibold px-8 py-4 rounded-lg hover:bg-sage/90 transition-colors duration-200 text-[#E7EEEE] bg-[#3D7B6F]" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-68">
              interesante leer mas de la guia a continuacion
            </motion.a>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-69">
            <img src="https://cdn.magicpatterns.com/uploads/6w35BMW2YDb7ADxtEv8L1H/heylloyd-image-1775844303179.png" alt="Mujer sosteniendo tablet con eBook Calmante Natural Ansiedad 24h" className="w-full rounded-2xl shadow-2xl" data-id="element-70" />
          </motion.div>
        </div>
      </div>
    </section>;
}